import React, { useEffect } from 'react';
import './Navigator.scss'

const Navigator = ({data, index, onSelect}) => {

  useEffect(() => {
  }, [index])

  const handleOnDotClick = (i) => {
    onSelect(i);
  }

  return (
    <div className="navigator-container">
      { index !== 0 &&
        <i className="navigator-controls fa fa-chevron-left" onClick={ () => { onSelect(index - 1) } } />
      }
      { data &&
        data.map( (item, i) => (
          <span key={`dot-${i}`} className={`fas fa-circle navigator-dot ${i===index ? 'active' : ''}`} onClick={ () => { handleOnDotClick(i) }} />
        ) )
      }
      { index + 1 < data.length &&
        <i className="navigator-controls fa fa-chevron-right" onClick={ () => { onSelect(index + 1) } } />
      }
    </div>
  );

}

export default Navigator;
